import { ExplorableItemDefinition } from './ContentDefinitionsTypes';
import { Messages } from '../../../codegen/Localize';
import { TableContentType, TableWithCrassContentType } from '../ContentTypes';
import { getGenericDefaultFilters } from './getDefaultFilters';
import { GenericCard } from '../../../app/spaces/CardView/GenericCard';
import { TablesGraphQLResourceQuery } from '../../../catalog/fetchers/TablesGraphQLResourceQuery';
import { TablesWithCrass } from '../../../catalog/resources/TablesWithCrass';

export const TableDefinition: ExplorableItemDefinition = {
  itemType: 'table',
  pluralName: Messages.tables,
  emptyStateMessage: Messages.tablesEmptyMessage,
  contentFilterKeys: TableContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: null,
  getBasicQuery: () => new TablesGraphQLResourceQuery(),
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};

export const TableWithCrassDefinition: ExplorableItemDefinition = {
  itemType: 'tableWithCrass',
  pluralName: Messages.tables,
  emptyStateMessage: Messages.tablesEmptyMessage,
  contentFilterKeys: TableWithCrassContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: null,
  getBasicQuery: () => {
    return TablesWithCrass.all().withExtraParams(TableContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
